import React from "react";
import base from "../themes/base";
import { Box, BoxProps } from "../box/Box";
import { Text } from "../text/Text";
import styled from "styled-components";

export interface PageSectionProps extends BoxProps {
    heading?: string;
    headingColor?: string;
    body?: string;
    bodyColor?: string;
    textAlign?: "left" | "center";
    isScreenReaderOnly?: boolean;
    boxProps?: [];
    paperTear?: boolean
}

const Container = styled(Box)<{paperTear?: boolean}>`
    position: relative;
    &:has(.oui-paper-tear) {
        padding-bottom: 16px !important;
        &::after {
            content: "";
            display: block;
            background-image: url("https://images.ctfassets.net/nfc1w9qpk6sl/4VblbdKbpbYfI7UGzFJFu3/eb7d481c43738302ccf22ac7b142b157/paper_tear_white.png");
            background-repeat: repeat-x;
            bottom: 0;
            left: 0;
            position: absolute;
            z-index: 10;
            width: 100%;
            height: 32px;
            background-size: 1000px;
        }
    }
`

const PageSection: React.FC<React.PropsWithChildren<PageSectionProps>> = (
    {
        heading,
        isScreenReaderOnly = false,
        headingColor,
        body,
        bodyColor,
        textAlign = "center",
        borderColor,
        paperTear = false,
    children,
    ...rest
}) => {
    const borderProps = borderColor
        ? {
            borderColor,
            borderTop: "1px solid",
            borderBottom: "1px solid",
        }
        : {};

    return (
        <Container as="section" className="oui-page-section" py={[6, 6, 6, 7]} px={4} {...borderProps} {...rest}>
            {heading && (
                <Text
                    className={isScreenReaderOnly ? "sr-only" : ""}
                    as="h2"
                    typeStyle="title02"
                    textAlign={textAlign}
                    color={headingColor}
                    mb={heading && !body ? 6 : 0}
                >
                    {heading}
                </Text>
            )}
            {body && (
                <Text
                    as="p"
                    typeStyle="body"
                    textAlign={textAlign}
                    color={bodyColor}
                    maxWidth="640px"
                    mt={2}
                    mx={textAlign === "center" ? "auto" : undefined}
                    mb={6}
                >
                    {body}
                </Text>
            )}

            {children && (
                <Box maxWidth={base.gridMaxWidth} mx="auto" position="relative">
                    {children}
                    {paperTear && <div className="oui-paper-tear"></div>}
                </Box>
            )}
        </Container>
    );
};

export default PageSection;
